<template>
  <div class="bg_white">
    <van-nav-bar title="在线报名" left-text="" left-arrow @click-left="onClickLeft" @click-right="onClickRight">
      <template #right>
        <van-icon name="wap-home-o" size="20" />
      </template>
    </van-nav-bar>
    <van-cell-group>
      <template #title>
        <span class="title">请填写真实信息：</span>
      </template>
      <van-field v-model="param.realName" label="姓名：" placeholder="请输入您的真实姓名" />
      <van-field name="radio" label="性别：">
        <template #input>
          <van-radio-group v-model="param.sex" direction="horizontal">
            <van-radio :name="1" checked-color="#7080ff">男</van-radio>
            <van-radio :name="2" checked-color="#7080ff">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field v-model="param.address" label="通信地址：" placeholder="街道/楼牌号" />
      <van-field v-model="param.company" label="工作单位：" placeholder="工作单位名称" />
      <van-field v-model="param.jobPosition"  label="职务：" placeholder="请选择您的职务" readonly right-icon="arrow" @click="showPickerJob=true" />

      <van-field v-model="param.jobTime" label="任现职时间:" placeholder="请选择任现职时间" @click="showdatetime = true"
        right-icon="arrow" />
      <van-popup v-model="showdatetime" position="bottom">
        <van-datetime-picker v-model="currentDate" @cancel="showdatetime = false" @confirm="confirmDate" type="date"
          title="选择年月日" :min-date="minDate" :max-date="maxDate" />
      </van-popup>

      <van-field v-model="param.phone" label="联系电话：" placeholder="请输入您的联系电话" />

      <van-field v-model="applyType" readonly label="申领类型" placeholder="请选择申领类型" right-icon="arrow"
        @click="showApplyTypePicker = true" />
      <van-popup v-model="showApplyTypePicker" round position="bottom">
        <van-picker show-toolbar :columns="applyTypeList" @cancel="showApplyTypePicker = false"
          @confirm="confirmApplyType" value-key="dictLabel" />
      </van-popup>


      <van-field v-model="idCardType" readonly label="证件类型" placeholder="请选择证件类型" @click="showIdTypePicker = true"
        right-icon="arrow" />
      <van-popup v-model="showIdTypePicker" round position="bottom">
        <van-picker show-toolbar :columns="typelist" @cancel="showIdTypePicker = false" @confirm="confirmIdType"
          value-key="dictLabel" />
      </van-popup>
      <van-field v-model="param.idCardNo" label="证件号码" placeholder="请输入证件号码" />


      <van-field v-model="eduStr" readonly label="最高学历" placeholder="请选择最高学历" right-icon="arrow" @click="showEduPicker = true" />
      <van-popup v-model="showEduPicker" round position="bottom">
        <van-picker show-toolbar :columns="eduList" @cancel="showEduPicker = false" @confirm="confirmEdu"
          value-key="dictLabel" />
      </van-popup>

      <van-field v-model="applyWorkType" readonly label="单位类型" placeholder="请选择单位类型" right-icon="arrow"
        @click="showWorkTypePicker = true" />
      <van-popup v-model="showWorkTypePicker" round position="bottom">
        <van-picker show-toolbar :columns="workTypeList" @cancel="showWorkTypePicker = false" @confirm="confirmWorkType"
          value-key="dictLabel" />
      </van-popup>

      <van-field v-model="quaType" readonly label="资格类型" placeholder="请选择资格类型" right-icon="arrow"
        @click="showQuaTypePicker = true" />
      <van-popup v-model="showQuaTypePicker" round position="bottom">
        <van-picker show-toolbar :columns="quaList" @cancel="showQuaTypePicker = false" @confirm="confirmQuaType"
          value-key="dictLabel" />
      </van-popup>

    </van-cell-group>

    <van-cell-group>
      <template #title>
        <span class="title">白底2寸彩照：</span>
      </template>
      <div class="pd16 flex upImg">
        <van-uploader v-model="file1" multipart :max-count="1" upload-text="白底2寸彩照" :after-read="afterRead">
          <span class="iconfont" style="font-size:110px;color: #cccccc;">&#xe647;</span>
        </van-uploader>

      </div>
    </van-cell-group>

    <van-cell-group>
      <template #title>
        <span class="title">身份证复印件：</span>
      </template>
      <div class="pd16 flex upImg">
        <van-uploader v-model="file2" multipart :max-count="1" upload-text="身份证复印件" :after-read="afterRead1">
          <span class="iconfont" style="font-size:110px;color: #cccccc;">&#xe647;</span>

        </van-uploader>

      </div>
    </van-cell-group>

    <van-cell-group v-if="param.applyType == 1">
      <template #title>
        <span class="title">学历复印件：</span>
      </template>
      <div class="pd16 flex upImg">
        <van-uploader v-model="file4" multipart :max-count="1" upload-text="学历复印件" :after-read="afterRead3">
          <span class="iconfont" style="font-size:110px;color: #cccccc;">&#xe647;</span>
        </van-uploader>
      </div>
    </van-cell-group>

    <van-cell-group v-if="param.applyType > 1">
      <template #title>
        <span class="title">证书正面照片：</span>
      </template>
      <div class="pd16 flex upImg">
        <van-uploader v-model="file5" multipart :max-count="1" upload-text="证书正面照片" :after-read="afterRead4">
          <span class="iconfont" style="font-size:110px;color: #cccccc;">&#xe647;</span>
        </van-uploader>
      </div>
    </van-cell-group>

    <van-cell-group v-if="param.applyType > 1">
      <template #title>
        <span class="title">证书反面照片：</span>
      </template>
      <div class="pd16 flex upImg">
        <van-uploader v-model="file6" multipart :max-count="1" upload-text="证书反面照片" :after-read="afterRead5">
          <span class="iconfont" style="font-size:110px;color: #cccccc;">&#xe647;</span>
        </van-uploader>
      </div>
    </van-cell-group>

    <!-- <van-cell-group>
      <template #title>
        <span class="title">八闽健康码：</span>
      </template>
      <div class="pd16 flex upImg">
        <van-uploader v-model="file3" multipart :max-count="1" upload-text="八闽健康码" :after-read="afterRead2">
          <span class="iconfont" style="font-size:110px;color: #cccccc;">&#xe647;</span>
        </van-uploader>

      </div>
    </van-cell-group> -->

    <div class="pd16 m40">
      <van-button class="btn_bg" round block type="default" size="large" @click="onSubmit">提交报名</van-button>
    </div>

    <van-popup v-model="showPicker" round position="bottom">
      <van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" />
    </van-popup>

    <van-popup v-model="showPickerJob" round position="bottom">
      <van-picker show-toolbar :columns="joblist" @cancel="showPickerJob = false" @confirm="onConfirmJob" />
    </van-popup>
  </div>
</template>

<script>
//考核合格证培训
import { upload } from "../../api/upload"
import { getDictData, signUp, getSignUpDetail } from "../../api/custom";
export default {
  data() {
    return {
      joblist:['主要负责人','安全管理人员'],
      showPickerJob:false,
      applyType: '',
      applyWorkType: '',
      quaType: '',
      eduStr: '',
      idCardType: '身份证',
      showIdTypePicker: false,
      showApplyTypePicker: false,
      showWorkTypePicker: false,
      showQuaTypePicker: false,
      showEduPicker: false,
      showdatetime: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(2021, 0, 17),
      showPicker: false,
      columns: [
        '已婚', '未婚'
      ],
      file1: [],
      file2: [],
      file3: [],
      file4: [],
      file5: [],
      file6: [],
      param: {
        realName: '',
        sex: 1,
        idCardType: 1,
        idCardNo: '',
        edu: '',
        phone: '',
        company: '',
        address: '',
        jobPosition: '',
        jobTime: '',
        applyWorkType: '',
        applyQualification: '',
        applyType: '',
        studentPhoto: '',
        idCardPhoto: '',
        eduPhoto: '',
        healthPhoto: '',
        cerPhoto1: '',
        cerPhoto2: '',
        studentType: 1//1:考核培训 2安全培训 

      },
      typelist: ['身份证', '军官证', '护照', '其他'],
      applyTypeList: [],
      workTypeList: [],
      quaList: [],//资格list
      eduList: [],
    }

  },
  mounted() {
    this.getIdType()
  },
  methods: {
    async getIdType() {
      //证件类型
      await getDictData("sys_id_type").then(res => {
        this.typelist = res.data.list
      })
      //申领资格
      await getDictData("sys_apply_type").then(res => {
        this.applyTypeList = res.data.list
      })
      //最高学历
      await getDictData("sys_edu").then(res => {
        this.eduList = res.data.list
      })
      //单位类型
      await getDictData("sys_work_type").then(res => {
        this.workTypeList = res.data.list
      })
      //资格类型
      await getDictData("sys_qulification_type").then(res => {
        this.quaList = res.data.list
      })

      if (this.common.getQueryString("id") != null) {
        let that = this
        await getSignUpDetail(this.common.getQueryString("id")).then(res => {
          this.param = res.data.result
          this.eduList.forEach(item => {
            if (item.dictValue == that.param.eduid) {
              that.eduStr = item.dictLabel
            }
          })
          this.workTypeList.forEach(item => {
            if (item.dictValue == that.param.applyWorkType) {
              that.applyWorkType = item.dictLabel
            }
          })
          this.applyTypeList.forEach(item => {
            if (item.dictValue == that.param.applyType) {
              that.applyType = item.dictLabel
            }
          })
          this.quaList.forEach(item => {
            if (item.dictValue == that.param.applyQualification) {
              that.quaType = item.dictLabel
            }
          })
          //2寸彩照
          if (this.param.studentPhoto != '') {
            this.file1 = [{
              url: this.common.getImageUrl(this.param.studentPhoto),
            }]

          }

          //身份证彩照
          if (this.param.idCardPhoto != '') {
            this.file2 = [{
              url: this.common.getImageUrl(this.param.idCardPhoto),
            }]
          }

          //健康二维码
          if (this.param.healthPhoto != '') {
            this.file3 = [{
              url: this.common.getImageUrl(this.param.healthPhoto),
            }]
          }


          //学历
          if (this.param.eduPhoto != '') {
            this.file4 = [{
              url: this.common.getImageUrl(this.param.eduPhoto),
            }]
          }

          //正面证件照
          if (this.param.cerPhoto1 != '') {
            this.file5 = [{
              url: this.common.getImageUrl(this.param.cerPhoto1),
            }]
          }

          //反面证件照
          if (this.param.cerPhoto2 != '') {
            this.file6 = [{
              url: this.common.getImageUrl(this.param.cerPhoto2),
            }]
          }


        })
      }

    },
    confirmIdType(value, index) {
      console.log(`当前值：${value}, 当前索引：${index}`)
      this.idCardType = this.typelist[index].dictLabel
      this.param.idCardType = Number(this.typelist[index].dictValue)
      this.showIdTypePicker = false
    },
    confirmWorkType(value, index) {
      console.log(`当前值：${value}, 当前索引：${index}`)
      this.applyWorkType = this.workTypeList[index].dictLabel
      this.param.applyWorkType = this.workTypeList[index].dictValue
      this.showWorkTypePicker = false
    },
    confirmApplyType(value, index) {
      console.log(`当前值：${value}, 当前索引：${index}`)
      this.applyType = this.applyTypeList[index].dictLabel
      this.param.applyType = this.applyTypeList[index].dictValue
      this.showApplyTypePicker = false
    },
    confirmQuaType(value, index) {
      console.log(`当前值：${value}, 当前索引：${index}`)

      if(this.param.applyWorkType <7){
       if(value.dictValue ==3 || value.dictValue ==4  || value.dictValue ==5){
         this.showQuaTypePicker = false
         alert("该单位类型仅可选择主要负责人或者安全生产管理人员")
         return
       }
         
      }
      this.quaType = this.quaList[index].dictLabel
      this.param.applyQualification = this.quaList[index].dictValue
      this.showQuaTypePicker = false
    },
    confirmEdu(value, index) {
      console.log(`当前值：${value}, 当前索引：${index}`)
      this.eduStr = this.eduList[index].dictLabel
      this.param.eduid = Number.parseInt(this.eduList[index].dictValue)
      this.showEduPicker = false
    },
    confirmDate(value) {
      this.showdatetime = false
      let Y = value.getFullYear()
      let M = value.getMonth() + 1 < 10 ? '0' + (value.getMonth() + 1) : value.getMonth() + 1
      let D = value.getDate()
      this.param.jobTime = `${Y}-${M}-${D}`
    },
    //2寸免冠照
    afterRead(file) {
      let that = this
      file.status = 'uploading';
      file.message = 'uploading...';
      upload(file).then(res => {
        console.log(res)
        let resp = res.data;
        if (resp.success) {
          that.param.studentPhoto = resp.data.fileName;
          file.status = 'success';
          file.message = 'success'
          console.log(that.param.studentPhoto)
        }
      })
    },
    //身份证上传
    afterRead1(file) {
      let that = this
      file.status = 'uploading';
      file.message = 'uploading...';
      upload(file).then(res => {
        console.log(res)
        let resp = res.data;
        if (resp.success) {
          that.param.idCardPhoto = resp.data.fileName;
          file.status = 'success';
          file.message = 'success'
          console.log(that.param.idCardPhoto)
        }

      })
    },
    //二维码上传
    afterRead2(file) {
      let that = this
      file.status = 'uploading';
      file.message = 'uploading...';
      upload(file).then(res => {
        console.log(res)
        let resp = res.data;
        if (resp.success) {
          that.param.healthPhoto = resp.data.fileName;
          file.status = 'success';
          file.message = 'success'
          console.log(that.param.healthPhoto)
        }

      })
    },
    //学历证书
    afterRead3(file) {
      let that = this
      file.status = 'uploading';
      file.message = 'uploading...';
      upload(file).then(res => {
        console.log(res)
        let resp = res.data;
        if (resp.success) {
          that.param.eduPhoto = resp.data.fileName;
          file.status = 'success';
          file.message = 'success'
          console.log(that.param.healthPhoto)
        }

      })
    },
    //证书正面
    afterRead4(file) {
      let that = this
      file.status = 'uploading';
      file.message = 'uploading...';
      upload(file).then(res => {
        console.log(res)
        let resp = res.data;
        if (resp.success) {
          that.param.cerPhoto1 = resp.data.fileName;
          file.status = 'success';
          file.message = 'success'
          console.log(that.param.healthPhoto)
        }

      })
    },
    //证书反面
    afterRead5(file) {
      let that = this
      file.status = 'uploading';
      file.message = 'uploading...';
      upload(file).then(res => {
        console.log(res)
        let resp = res.data;
        if (resp.success) {
          that.param.cerPhoto2 = resp.data.fileName;
          file.status = 'success';
          file.message = 'success'
          console.log(that.param.healthPhoto)
        }

      })
    },
    onClickLeft() {
      this.$router.back()
    },
    onClickRight() {
      this.$router.push("/home")
      //Toast('按钮');
    },
    onSubmit() {
      console.log(this.param)
      let that = this
      console.log(that.param)
      //判断身份证
      if (this.param.idCardType == 1 && this.param.idCardNo.length != 18) {
        this.$dialog.alert({
          message: "身份证位数不对",
          theme: 'round-button',
          confirmButtonText: '确定'
        })
        return;
      }
      //判断2寸照片
      if(this.param.studentPhoto =='' || this.param.studentPhoto == null){
        this.$dialog.alert({
          message: "请上传2寸照片",
          theme: 'round-button',
          confirmButtonText: '确定'
        })
        return;
      }
      if((this.param.applyType == 1) && (this.param.eduPhoto =='' || this.param.eduPhoto == null)){
        this.$dialog.alert({
          message: "请上传学历照片",
          theme: 'round-button',
          confirmButtonText: '确定'
        })
        return;
      }
      if(this.param.idCardPhoto =='' || this.param.idCardPhoto == null){
        this.$dialog.alert({
          message: "请上传身份证照片",
          theme: 'round-button',
          confirmButtonText: '确定'
        })
        return;
      }

      if((this.param.applyType > 1) && (this.param.cerPhoto1 =='' || this.param.cerPhoto1 == null)){
        this.$dialog.alert({
          message: "请上传证书正面",
          theme: 'round-button',
          confirmButtonText: '确定'
        })
        return;
      }

      if((this.param.applyType > 1) && (this.param.cerPhoto2 =='' || this.param.cerPhoto2 == null)){
        this.$dialog.alert({
          message: "请上传证书反面",
          theme: 'round-button',
          confirmButtonText: '确定'
        })
        return;
      }

      signUp(that.param).then(res => {
        if (res.success) {
          this.$dialog.alert({
            title: '提交成功',
            message: '请将所有材料纸质版提交到协会办公室才算正式报名成功',
          }).then(() => {
            // on close
            that.$router.push('/signupList')
          })
          // this.$toast({
          //   type: 'success',
          //   message: '资料提交成功',
          //   onClose: function () {
          //     that.$router.push('/signupList')
          //   }
          // })
        } else {
          this.$toast({
            type: 'fail',
            message: res.message,

          })
        }
      })
    },
    onConfirm(value) {
      this.married = value;
      this.showPicker = false;
    },
    onConfirmJob(value) {
      this.param.jobPosition = value;
      this.showPickerJob = false;
    },

  }

};
</script>

<style lang="less">
.upImg {
  justify-content: space-around;
  padding-bottom: 10px;
}

.tip {
  width: 100%;
  display: block;
  text-align: center;
  position: absolute;
  z-index: 2;
  height: 20px;
  line-height: 20px;
  margin-top: -20px;
  font-size: 14px;
  color: #ccc;
}

.title {
  color: #000000;
}
</style>

